
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path d="M17 11.1666H22V12.8333H17V11.1666Z"></path><path opacity="0.4" d="M14.9463 16.1249L16.1248 14.9464L19.6603 18.4819L18.4818 19.6604L14.9463 16.1249Z"></path><path opacity="0.4" d="M11.1667 17H12.8333V22H11.1667V17Z"></path><path opacity="0.4" d="M4.33904 18.4822L7.87457 14.9466L9.05308 16.1252L5.51755 19.6607L4.33904 18.4822Z"></path><path opacity="0.4" d="M2 11.1666H7V12.8333H2V11.1666Z"></path><path opacity="0.4" d="M4.33904 5.51831L5.51755 4.3398L9.05308 7.87533L7.87457 9.05384L4.33904 5.51831Z"></path><path opacity="0.6" d="M11.1667 2H12.8333V7H11.1667V2Z"></path><path opacity="0.8" d="M14.9457 7.87537L18.4812 4.33983L19.6597 5.51834L16.1242 9.05388L14.9457 7.87537Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowshowloadingFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
